import { $ } from '@zeus/index'
import { typedGql } from '@zeus/typedDocumentNode'
import { scalars } from '~/gql/utils/scalars'

const questionFields = {
  interactionId: true,
  description: true,
  type: true,
  correctResponses: true,
  respondents: true,
  correctRate: true,
  averageScore: true,
  buckets: true,
} as const

/** Analyse par question d'un module (#159) : les agrégats, ce que l'écran affiche. */
export const GQL_MODULE_QUESTION_STATS = typedGql('query', { scalars })({
  moduleQuestionStats: [
    { input: $('input', 'ModuleQuestionsInput!') },
    { questions: questionFields, learners: { id: true, firstName: true, lastName: true, email: true } },
  ],
})

/**
 * La même analyse avec la réponse de chaque apprenant, lue seulement pour les
 * exports CSV : apprenants × questions, trop lourd pour l'écran qui ne s'en sert pas.
 */
export const GQL_MODULE_QUESTION_ANSWERS = typedGql('query', { scalars })({
  moduleQuestionStats: [
    { input: $('input', 'ModuleQuestionsInput!') },
    {
      questions: { ...questionFields, answers: { userId: true, response: true, result: true, score: true, attemptNumber: true } },
      learners: { id: true, firstName: true, lastName: true, email: true },
    },
  ],
})

/** Les tentatives d'un apprenant sur un module, et leurs réponses (#159). */
export const GQL_LEARNER_MODULE_ATTEMPTS = typedGql('query', { scalars })({
  learnerModuleAttempts: [
    { input: $('input', 'LearnerModuleAttemptsInput!') },
    {
      sessionId: true,
      sessionName: true,
      number: true,
      completionStatus: true,
      successStatus: true,
      scoreRaw: true,
      scoreMax: true,
      scoreScaled: true,
      totalTime: true,
      updatedAt: true,
      interactions: { index: true, interactionId: true, description: true, correctResponses: true, learnerResponse: true, result: true },
    },
  ],
})

// Types concrets pour le rendu : les `InputType` zeus résolvent leurs champs en
// `unknown` (inexploitables en accès de champ), d'où ces formes explicites.
export type QuestionAnswer = { userId: string, response?: string | null, result?: string | null, score?: number | null, attemptNumber: number }

export type QuestionStat = {
  interactionId: string
  description?: string | null
  type?: string | null
  correctResponses: string[]
  respondents: number
  correctRate?: number | null
  averageScore?: number | null
  buckets: number[]
  /** Lues seulement pour les exports (`GQL_MODULE_QUESTION_ANSWERS`). */
  answers?: QuestionAnswer[]
}

export type QuestionLearner = { id: string, firstName: string, lastName: string, email: string }
